/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from 'pinia';
import Axios from '@auth/vue-share/utility/axios';

export const useConfigStore = defineStore('config', {
    state: () => ({
        config: undefined
    }),
    getters: {
        getConfig: (state) => state.config,
        get:
            (state) =>
            (path, fallback = undefined) => {
                if (!state.config) return fallback;

                const segments = path.split('.');
                let object = undefined;

                for (const entry of segments) {
                    if (!object) {
                        object = state.config[entry];
                    } else {
                        object = object[entry];
                    }

                    if (!object) break;
                }

                return object ?? fallback;
            }
    },
    actions: {
        fetchConfig() {
            return new Promise((resolve, reject) => {
                Axios.get('config', `/api/config/appearance`)
                    .then((response) => {
                        this.config = response.data.data;
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
});
